// NBA personal fouls for the leg's player, e.g. "3 PF"; foul trouble turns it orange, 5 fouls red, 6 = fouled out.
const LOOK = {
  trouble: 'bg-orange-500 text-black',
  danger: 'bg-red-600 text-white animate-pulse',
  fouled_out: 'bg-red-700 text-white',
};

export const FoulTag = ({ leg }) => {
  if (leg.fouls == null || String(leg.league || '').toLowerCase() !== 'nba') return null;
  const ft = leg.foul_trouble;
  const out = leg.fouls >= 6;
  return (
    <span className={`rounded px-1 text-[8px] font-black leading-[13px] tracking-wide ${LOOK[ft] || 'bg-zinc-700 text-zinc-100'}`}
      data-testid={`fouls-${leg.id}`} title={out ? 'Fouled out' : `${leg.fouls} personal foul${leg.fouls === 1 ? '' : 's'}${ft ? ' — foul trouble' : ''}`}>
      {out ? 'FOULED OUT' : `${leg.fouls} PF`}
    </span>
  );
};

// Bar inside the leg while the player is in foul trouble (live games only).
export const FoulTroubleBar = ({ leg, big = false }) => {
  const ft = leg.foul_trouble;
  if (!ft || String(leg.performance_status || '').startsWith('FINAL') || String(leg.league || '').toLowerCase() !== 'nba') return null;
  const text = ft === 'fouled_out' ? 'FOULED OUT — 6 fouls' : ft === 'danger' ? `FOUL TROUBLE — ${leg.fouls} fouls, one more and he's out` : `FOUL TROUBLE — ${leg.fouls} fouls`;
  return (
    <div className={`mt-0.5 rounded px-1 font-black truncate ${big ? 'text-[11px] leading-5 py-0.5' : 'text-[9px] leading-4 pr-16'} ${LOOK[ft]}`} data-testid={`foul-trouble-${leg.id}`} data-level={ft}>
      {text}
    </div>
  );
};
